var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.07227 14.0329V12.1996C3.07227 11.1163 3.95769 10.2204 5.05144 10.2204C6.93686 10.2204 7.70769 8.88708 6.75977 7.25167C6.21811 6.31417 6.54102 5.09542 7.48894 4.55375L9.29102 3.5225C10.1139 3.03292 11.1764 3.32458 11.666 4.1475L11.7806 4.34542C12.7181 5.98083 14.2598 5.98083 15.2077 4.34542L15.3223 4.1475C15.8118 3.32458 16.8743 3.03292 17.6973 3.5225L19.4993 4.55375C20.4473 5.09542 20.7702 6.31417 20.2285 7.25167C19.2806 8.88708 20.0514 10.2204 21.9368 10.2204C23.0202 10.2204 23.916 11.1058 23.916 12.1996V14.0329C23.916 15.1163 23.0306 16.0121 21.9368 16.0121C20.0514 16.0121 19.2806 17.3454 20.2285 18.9808C20.7702 19.9288 20.4473 21.1371 19.4993 21.6788L17.6973 22.71C16.8743 23.1996 15.8118 22.9079 15.3223 22.085L15.2077 21.8871C14.2702 20.2517 12.7285 20.2517 11.7806 21.8871L11.666 22.085C11.1764 22.9079 10.1139 23.1996 9.29102 22.71L7.48894 21.6788C6.54102 21.1371 6.21811 19.9183 6.75977 18.9808C7.70769 17.3454 6.93686 16.0121 5.05144 16.0121C3.95769 16.0121 3.07227 15.1163 3.07227 14.0329Z",
    fill: "#347D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4889 16.508C15.3586 16.508 16.8743 14.9923 16.8743 13.1226C16.8743 11.2529 15.3586 9.73718 13.4889 9.73718C11.6192 9.73718 10.1035 11.2529 10.1035 13.1226C10.1035 14.9923 11.6192 16.508 13.4889 16.508Z",
    fill: "#347D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon01);
export default __webpack_public_path__ + "static/media/setting-icon-01.1a3bfd2ececf31b44cd1fc4f284a08c2.svg";
export { ForwardRef as ReactComponent };